/*
 * @Author: yzhao
 * @Date: 2022-06-29 15:42:02
 * @LastEditors: wli
 * @LastEditTime: 2022-07-29 16:46:42
 * @Description: file content
 */
let xmlRequest = `
<?xml version="1.0" encoding="utf-8"?>
<request>
    <outBizCode>外部业务编码, string (50), 必填, 消息ID, 用于去重，因为网络等原因导致重复传输，请求不会被重复处理</outBizCode>
    <orders>
        <order>
            <entryOrder>
                <entryOrderCode>入库单号, string (50), 必填</entryOrderCode>
                <ownerCode>货主编码, string (50), 必填</ownerCode>
                <warehouseCode>仓库编码, string (50), 必填</warehouseCode>
                <orderCreateTime>订单创建时间, string (19), YYYY-MM-DD HH:MM:SS</orderCreateTime>
                <isRelease>释放状态, string (50), 0=未释放, 1=已释放, 2=未控制，默认:2(只传数字)</isRelease>
                <orderType>入库单类型, string (50), 例如: CGRK=采购入库、DBRK=调拨入库 、THRK=退货入库, QTRK=其他入库(只传英文编码), 必填</orderType>
                <expectStartTime>预期到货时间, string (19), YYYY-MM-DD HH:MM:SS</expectStartTime>
                <logisticsName>物流公司名称, string (200)</logisticsName>
                <expressCode>运单号, string (50)</expressCode>
                <supplierCode>供应商编码, string (50)，采购入库取供应商编码, 调拨入库取调出方编码、退货入库取客户编码、其他入库取公司编码</supplierCode>
                <supplierName>供应商名称, string (200)，采购入库取供应商名称, 调拨入库取调出方名称、退货入库取客户名称、其他入库取公司名称</supplierName>
                <documentMaker>制单人, string (50)</documentMaker>
                <remark>备注, string (500)</remark>
                <userDefined1>自定义1, string (50)</userDefined1>
                <userDefined2>自定义2, string (50)</userDefined2>
                <userDefined3>自定义3, string (50)</userDefined3>
                <userDefined4>自定义4, string (50)</userDefined4>
                <outBizCode>外部业务编码, string (50), 消息ID, 用于去重，因为网络等原因导致重复传输，请求不会被重复处理</outBizCode>
            </entryOrder>
            <orderLines>
                <orderLine>
                    <ownerCode>货主编码, string (50), 必填</ownerCode>
                    <itemCode>商品编码, string (50), 必填</itemCode>
                    <itemId>仓储系统商品ID, string (50)</itemId>
                    <itemName>商品名称, string (200)</itemName>
                    <planQty>应收商品数量, float, 必填</planQty>
                    <virtualWarehouse>虚拟仓库, string (50), 条件必填, 条件为使用虚拟仓库</virtualWarehouse>
                    <inventoryType>质量状态, string (50), ZP=正品, CC=残次, 默认为ZP</inventoryType>
                    <productDate>商品生产日期, string (10), YYYY-MM-DD</productDate>
                    <expireDate>商品过期日期, string (10), YYYY-MM-DD</expireDate>
                    <batchCode>批次号, string (50)</batchCode>
                    <stockinDate>商品入库日期, string (10), YYYY-MM-DD</stockinDate>
                    <userDefined1>自定义批次1, string (50)</userDefined1>
                    <userDefined2>自定义批次2, string (50)</userDefined2>
                    <userDefined3>自定义批次3, string (50)</userDefined3>
                    <userDefined4>自定义批次4, string (50)</userDefined4>
                    <lineNo>行号, int</lineNo>
                    <customJson>自定义json</customJson>
                    <customField1>自定义字段1, string (50)</customField1>
                    <customField2>自定义字段2, string (50)</customField2>
                    <customField3>自定义字段3, string (50)</customField3>
                    <customField4>自定义字段4, string (50)</customField4>
                    <customField5>自定义字段5, string (50)</customField5>
                    <customField6>自定义字段6, string (50)</customField6>
                    <customField7>自定义字段7, string (50)</customField7>
                    <customField8>自定义字段8, string (50)</customField8>
                </orderLine>
            </orderLines>
        </order>
    </orders>
</request>
`

let xmlResponse = `
<?xml version="1.0" encoding="utf-8"?>
<response>
    <flag>success|failure</flag>
    <code>响应码</code>
    <orders>
        <order>
            <entryOrderId>仓储系统入库单号, string (50)，出错的入库单号</entryOrderId>
            <message>响应信息</message>
        </order>
    </orders>
</response>
`

export default { xmlRequest, xmlResponse }


// WEBPACK FOOTER //
// ./src/data/openapi/openapi.entryorder.batchcreate.js